import { isEmpty, trim } from 'lodash/fp';
import pt from 'prop-types';
import { Component } from 'react';
import { LocalizationSubscribeContext, type LocalizedPropertyObject } from '@mews/framework';
import { SimpleMarkdown, type SimpleMarkdownProps } from './SimpleMarkdown';

type LocalizedMarkdownProps = Omit<SimpleMarkdownProps, 'text'> & {
    property: LocalizedPropertyObject | null | undefined;
};

type LocalizationSubscribe = LocalizationSubscribeContext['localizationSubscribe'];

interface LocalizedMarkdownContext extends LocalizationSubscribeContext {
    localizeProperty: (property: LocalizedPropertyObject | null | undefined) => string;
    localizationSubscribe: LocalizationSubscribe;
}

export class LocalizedMarkdown extends Component<LocalizedMarkdownProps> {
    declare context: LocalizedMarkdownContext;
    static contextTypes = {
        localizationSubscribe: pt.func.isRequired,
        localizeProperty: pt.func.isRequired,
    };
    private unsubscribe: (() => void) | null = null;

    componentDidMount() {
        this.unsubscribe = this.context.localizationSubscribe(() => this.forceUpdate());
    }

    componentWillUnmount() {
        this.unsubscribe?.();
    }

    render() {
        const { property, ...others } = this.props;
        const localizedText = trim(this.context.localizeProperty(property));

        return !isEmpty(localizedText) ? <SimpleMarkdown {...others} text={localizedText} /> : null;
    }
}
